import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {bindActionCreators} from 'redux';
import StandardModal, { ModalSize } from '../../Fundamentals/Modal/StandardModal';
import useModal from '../../../Hooks/useModal';
import appConfigActions from "../../../Actions/appConfigActions";
import formActionsImp from "../../../Actions/formActions";
import {AppConfigForm} from "../../Settings/AppConfig/AppConfigForm";

const AppConfigModal = ({ config }) => {
    const dispatch = useDispatch();
    const { closeModal } = useModal();
    const formActions = bindActionCreators(formActionsImp, dispatch);
    const actions = bindActionCreators(appConfigActions, dispatch);
    const form = useSelector((state) => state.FormReducer.forms[config.name]);
    const [isEditingRow, setIsEditingRow] = useState(false);

    const onSubmit = () => {
        actions.saveConfiguration(form, closeModal);
    }

    const onClose = () => {
        formActions.cancelFormEditing(form.id);
        closeModal();
    }

    return (
        <StandardModal 
            title={`Edit config: ${config.name}`} 
            size={ModalSize.X_LARGE} 
            onClose={onClose}
            onSubmit={isEditingRow ? null : onSubmit}
        >
            <>
                <div className="mb-24">
                    {config.description}
                </div>
                <AppConfigForm 
                    config={config}
                    onEditingStateChange={setIsEditingRow}
                />
            </>
        </StandardModal>
    );
};

export default AppConfigModal;
